import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import './plugins/axios'

Vue.config.productionTip = false;

let vue = new Vue({
    router,
    render: h => h(App)
}).$mount('#app')

// 这个是单例全局，用一个即可
let fullLoading = null;
// 数据并发时，后面的id会冲掉前面的id，导致前面定时的loading无法清除，所以只能是数组
let timeIds = [];

const closeLoading = () => {
    timeIds.forEach(item => clearTimeout(item));
    if (fullLoading) {
        vue.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
            fullLoading.close();
        });
    }
    timeIds = [];
};

vue.$axios.interceptors.request.use(
    (config) => {
        config.headers['Authorization'] = localStorage.getItem("token");
        // Do something before request is sent
        timeIds.push(setTimeout(() => {
            fullLoading = vue.$loading({
                fullscreen: true,
                background: 'rgba(0, 0, 0, 0.7)'
            });
        }, 1000));
        return config;
    },
    (error) => {
        // Do something with request error
        closeLoading();
        return Promise.reject(error);
    }
);

// Add a response interceptor
vue.$axios.interceptors.response.use(
    (response) => {
        // Do something with response data
        let token = response.headers['authorization'];
        if (token) {
            localStorage.setItem("token", token);
        }
        closeLoading();
        return response;
    },
    (error) => {
        // Do something with response error
        closeLoading();
        return Promise.reject(error);
    }
);


//上传文件兼容IE11
if (!FileReader.prototype.readAsBinaryString) {
    FileReader.prototype.readAsBinaryString = function (fileData) {
        var binary = "";
        var pt = this;
        var reader = new FileReader();
        reader.onload = function (e) {
            var bytes = new Uint8Array(reader.result);
            var length = bytes.byteLength;
            for (var i = 0; i < length; i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            //pt.result  - readonly so assign binary
            pt.content = binary;
            pt.onload();
        };
        reader.readAsArrayBuffer(fileData);
    }
}